module.exports = __webpack_public_path__ + "media/assets/images/flags/gt-4ba535aeb8ab6dfeca126c3b2c6e601e.svg";